module.exports = __webpack_public_path__ + "img/地狱天使.ed12fe9a.jpg";